/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
function getRoundRobinIndex(index, total) {
  return (index + total) % total;
}

export { getRoundRobinIndex as g };
